<template>
  <div class="resource-downloader">
    <div v-if="isWeChat" class="open-tip">
      <div class="arrow-icon"></div>
      <span>{{ $t(`${i18nPrefix}.message.downloadResource.${sourceType}`) }}</span>
    </div>
    <div class="previewer" :class="fileType">
      <video
        v-if="fileType === 'video'"
        controls
        preload="auto"
        :src="fileSrc"
        @loadedmetadata="onLoadedMetadata"
      ></video>
    </div>
  </div>
</template>

<script>
import { deviceType } from '@/utils/common'
import { getFilePath } from '@/utils/qiniu'

export default {
  data () {
    return {
      i18nPrefix: 'common',
      fileSrc: null,
      showPreviewer: false
    }
  },
  computed: {
    sourceType () {
      return this.$route.query.source
    },
    fileType () {
      return this.$route.query.type
    },
    fileKey () {
      return this.$route.query.key
    },
    isWeChat () {
      return deviceType.isWeChat
    }
  },
  created () {
    if (!this.fileKey) {
      this.$router.back()
      return
    }
    if (this.sourceType === 'VIDEO_POSTER') {
      this.fileSrc = `${getFilePath(this.fileKey)}?v=${new Date().getTime()}`
      if (this.isWeChat) {
        this.showPreviewer = true
      } else {
        window.location.href = `${this.fileSrc}&attname=${new Date().getTime()}.mp4`
      }
    } else {
      window.location.href = `${getFilePath(this.fileKey)}`
    }
  },
  methods: {
    onLoadedMetadata ($event) {
      $event.target.pause()
    }
  }
}
</script>

<style lang="scss" scoped>
.resource-downloader {
  min-height: 100vh;
  padding: 70px 5%;
  color: #ffffff;
  font-size: 16px;
  background: #303030;

  .open-tip {
    margin-bottom: 20px;
    text-align: center;

    .arrow-icon {
      width: 90px;
      height: 70px;
      background-size: 300px;
      background-position: -215px 0px;
      background-repeat: no-repeat;
      background-image: url($baseDomain + 'static/image/mobile_web/wechat-share-chinese.png');
      position: absolute;
      top: 2px;
      right: 48px;
    }
  }

  .previewer {
    margin-top: 20px;

    video {
      width: 100%;
    }
  }
}
</style>
